import { Box, Stack, styled, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/swiper-react";
import { TIPPSPIEL_BOX_SHADOW } from "../../../styles";

export const SwiperContainer = styled(Box)({
    overflow: "visible",
    padding: "16px 16px 0 16px",
});

export const PromoPostsSwiperStyled = styled(Swiper)({
    position: "relative",
    overflow: "visible",
    "& .swiper-wrapper": {
        boxSizing: "border-box",
    },
    "& .swiper-pagination.swiper-pagination-bullets": {
        bottom: "-20px",
    },
    "& .swiper-pagination-bullet.swiper-pagination-bullet-active": {
        backgroundColor: "var(--community-color-deep-navy)",
    },
});

export const PostsPromoSwiperSlide = styled(SwiperSlide)({
    "&.swiper-slide": {
        height: "320px !important",
        boxSizing: "border-box",
        overflow: "hidden",
    },
});

export const PostImageGrid = styled(Box)({
    backgroundColor: "var(--community-color-transparent-black-05)",
    marginTop: "12px",
    ".grid-container": {
        padding: 0,
        ".cover-text>p": {
            color: "var(--community-color-snow-white)",
            fontSize: "32px",
        },
    },
    img: {
        objectFit: "cover",
    },
});

export const PostContentBox = styled(Box)({
    marginTop: "12px",
    "& p": { display: "inline" },
});

export const SwiperSlideStackFinal = styled(Stack)({
    width: "auto",
    margin: "0px 0px 16px",
    borderRadius: "12px",
    backgroundColor: "var(--community-color-snow-white)",
    boxShadow: TIPPSPIEL_BOX_SHADOW,
    transition: "box-shadow 0.3s ease-in-out",
    WebkitTapHighlightColor: "transparent",
    justifyContent: "space-around",
    gap: "18px",
    alignItems: "center",
    height: "calc(100% - 12px)",
    boxSizing: "border-box !important",
    padding: "72px 12px",
    "& .poll-text": {
        fontSize: "16px",
        fontWeight: 700,
    },
});

export const ShowMoreButton = styled(Typography)({
    fontWeight: 700,
    color: "var(--community-color-bright-azure)",
});

export const ButtonContainer = styled(Box)({
    padding: "0 1rem",
    textAlign: "right",
    marginTop: "1.25rem",
    boxShadow: "none",
});

export const BoxClickPrevent = styled(Box)({
    width: "100%",
    height: "100%",
    position: "absolute",
    opacity: 0.5,
    zIndex: 1,
});

export const BoxMainContent = styled(Box)({
    overflow: "hidden",
    flex: "3 1 auto",
    position: "relative",
    "& p": {
        lineHeight: "20px",
    },
});

export const BoxActions = styled(Box)({
    flex: "0 0 auto",
    position: "relative",
    boxShadow:
        "rgba(14, 30, 37, 0.12) 0px -8px 8px -8px, rgba(14, 30, 37, 0.32) 0px -8px 8px -8px",
});
